import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './../static/scss/App.scss';

class AppLayout extends Component {
  constructor(props) {
    super(props);

    let storageState = {};
    if (localStorage.nonWinner) {
      storageState.nonWinner = localStorage.nonWinner;
    }
    if (localStorage.fontColor) {
      storageState.fontColor = localStorage.fontColor;
    }
    if (localStorage.fontFamily) {
      storageState.fontFamily = localStorage.fontFamily;
    }

    this.state = {
      nonWinner: false,
      fontColor: null,
      fontFamily: null,
      ...storageState
    };
  }

  render() {
    const nonWinner = this.state.nonWinner == "true" ? true : false;
    const fontColor = this.state.fontColor;
    const fontFamily = this.state.fontFamily;

    let className;
    if (nonWinner) {
      className = "App appNonWinner";
    } else {
      className = "App appWinner";
    }

    return (
      <div className={className} style={{color: fontColor, fontFamily}}>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="page-transition"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {React.cloneElement(this.props.children, {
            key: location.pathname
          })}
        </ReactCSSTransitionGroup>
        {/* <Footer currentRoute={this.props.location.pathname}/> */}
      </div>
    )
  }
}

export default AppLayout;



// WEBPACK FOOTER //
// ./src/components/AppLayout.js